import React, { useState, useEffect, useContext, useRef } from 'react';
import UserContext from '../../components/User_Context.js';
import { useParams } from 'react-router-dom';
import * as menu from "../../assets/menus/menu.js"
import waiting from "../../assets/images/waiting.svg";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import * as utils from "../../components/utils.js";
import * as api from "../../api/apiConnector.js";
import ActivityUserLink from '../../components/activity_user_link.js';
import { useTranslation } from 'react-i18next';
import { ActivitiesLabels } from '../_label/activities/activities_labels.js';

const TaskEditor_Screen = (params) => {
    const { id } = useParams();
    const { t } = useTranslation();

    const [task, setTask] = useState(null);
    const [list, setList] = useState(null);
    const [board, setBoard] = useState(null);
    const rangeRef = useRef(null);
    const [toSave, SetToSave] = useState(false);
    const { currentUser } = useContext(UserContext);

    useEffect(() => {

        (async () => {
            // Initialize i18n labels from centralized file
            const i18n = menu.getI18n();
            i18n.addResourceBundle('it', 'labels', ActivitiesLabels.it, true, true);
            i18n.addResourceBundle('en', 'labels', ActivitiesLabels.en, true, true);
            
            // setBreadCrumb();
            menu.write({ user: currentUser() });
            await retrieveData();
            handleInputChange()
        })();
    }, []);


    useEffect(() => {
        if (task && list && board) {
            setBreadCrumb();
        }
    }, [task, list, board])



    const retrieveData = async () => {


        const task_result = await api.sendMessage("activity/task/getTask", {
            user: currentUser(),
            body: {
                taskId: id
            }

        });

        setTask(task_result.task);

        const list_result = await api.sendMessage("activity/list/getSingleList", {
            user: currentUser(),
            body: {
                listId: task_result.task.ActivityBoardListId
            }

        });
        setList(list_result.list);



        const board_result = await api.sendMessage("activity/board/getBoards", {
            user: currentUser(),
            body: {
                boardId: list_result.list.ActivityBoardId
            }

        });
        setBoard(board_result.boards[0]);

    }

    const handleInputChange = () => {
        if (rangeRef.current) {
            const value = rangeRef.current.value;
            rangeRef.current.style.setProperty('--progress', `${value}%`);
        }
    };


    const setBreadCrumb = (params) => {
        var path = [{
            link: "/",
            name: "Home"
        },
        {
            link: "/activity/board",
            name: t('yourBoards', { ns: 'labels' })
        },
        {
            link: "/activity/board",
            name: board?.Name ?? t('theBoard', { ns: 'labels' })
        },
        {
            link: `/activity/activityList/${list?.ActivityBoardId}`,
            name: list?.Name ?? t('activityList', { ns: 'labels' })
        },
        {
            link: `/activity/task/${id}`,
            name: task?.Name ?? t('thisTask', { ns: 'labels' })
        }
        ];
        breadcrumb.set(path);
    }




    const _remoteSearchUsers = async (text, usersType) => {

        const result = await api.sendMessage("activity/board/searchUsers", {
            user: currentUser(),
            body: {
                textToSearch: text
            }

        });


        switch (usersType) {

            case 'verifier':
                if (task?.VerifierUsers?.length > 0) {
                    result.users = result.users.filter(user =>
                        !task.VerifierUsers.some(linkedUser => linkedUser.Id === user.Id)
                    );
                }
                break;

            case 'validator':
                if (task?.ValidatorUsers?.length > 0) {
                    result.users = result.users.filter(user =>
                        !task.ValidatorUsers.some(linkedUser => linkedUser.Id === user.Id)
                    );
                }
                break;

            case 'executor':
                if (task?.ExecutorUsers?.length > 0) {
                    result.users = result.users.filter(user =>
                        !task.ExecutorUsers.some(linkedUser => linkedUser.Id === user.Id)
                    );
                }

                break;

            default:
                break

        }


        return result.users;
    }

    const _drawTask = () => {
        return (<>

            <div class="card-header">
                <div class="card-title" style={{ fontSize: 32 }}>{task?.Name} </div>
            </div>
            <div class="card-body ">
                <h4>{t('taskLinkedToList', { ns: 'labels' })} <strong>{list?.Name}</strong>, {t('fromTheBoard', { ns: 'labels' })} <strong>{board?.Name} </strong></h4>



                <div className='col-12'>
                    <label for="task_name" className="form-label">{t('name', { ns: 'labels' })}</label>


                    <input id="task_name" type="text" className="form-control" value={task.Name}
                        onChange={(e) => {
                            setTask(prevTask => ({
                                ...prevTask,
                                Name: e.target.value
                            }));
                            SetToSave(true);
                        }}
                        placeholder={t('nameTask', { ns: 'labels' })} />

                </div>

                <br></br>

                <div className='col-12'>
                    <label for="task_description" className="form-label">{t('description', { ns: 'labels' })}</label>

                    <textarea rows="3" id="task_description" type="text" className="form-control" value={task.Description}
                        onChange={(e) => {
                            setTask(prevTask => ({
                                ...prevTask,
                                Description: e.target.value
                            }));
                            SetToSave(true);
                        }}
                        placeholder={t('descriptionTask', { ns: 'labels' })}></textarea>

                </div>

                <br></br>

                <div className='row' style={{ verticalAlign: 'center' }}>
                    <div className='col-10'>
                        <label for="progress" class="form-label">{t('progress', { ns: 'labels' })}</label>
                        <input
                            ref={rangeRef}
                            type="range" class="form-range custom-range-progress" min="0" max="100" step="1.0" id="progress" value={task.Progress ?? 0}
                            onChange={(e) => {
                                setTask(prevTask => ({
                                    ...prevTask,
                                    Progress: e.target.value
                                }));
                                handleInputChange();
                                SetToSave(true);
                            }
                            }
                        />

                    </div>
                    <div className='col-2'>


                        <input id="task_progress" type="number" max='100' min='0' className="form-control" value={task.Progress ?? 0}
                            onChange={(e) => {
                                const progressValue = e.target.value > 100 ? 100 : e.target.value;
                                
                                if (e.target.value > 100) {
                                    withReactContent(Swal).fire({
                                        title: t('info', { ns: 'labels' }),
                                        icon: "info",
                                        text: t('progressLimitError', { ns: 'labels' }),
                                        showConfirmButton: true,
                                        timer: 1500
                                    });
                                }

                                setTask(prevTask => ({
                                    ...prevTask,
                                    Progress: progressValue
                                }));
                                SetToSave(true);
                            }}
                        />

                    </div>
                </div>

                <br></br>

                <div className='row'>
                    <div className='col-6'>
                        <label for="task_start_date" className="form-label">{t('startDate', { ns: 'labels' })}</label>

                        <input id="task_start_date" type="datetime-local" className="form-control"
                            ref={(r) => {
                                if (!r) return;
                                if (task.StartDate) {
                                    try {
                                        const date = new Date(task.StartDate);
                                        if (!isNaN(date.getTime())) {
                                            r.value = date.toISOString().slice(0, 16);
                                        }
                                    }
                                    catch (err) {
                                        r.value = '';
                                    }
                                }
                            }}

                            onChange={(e) => {
                                setTask(prevTask => ({
                                    ...prevTask,
                                    StartDate: e.target.value ? new Date(e.target.value).toISOString() : null
                                }));
                                SetToSave(true);
                            }}
                            placeholder={t('whenTaskNeedToStart', { ns: 'labels' })} />

                    </div>

                    <div className='col-6'>
                        <label for="task_end_date" className="form-label">{t('endDate', { ns: 'labels' })}</label>

                        <input id="task_end_date" type="datetime-local" className="form-control"
                            ref={(r) => {
                                if (!r) return;
                                if (task.EndDate) {
                                    try {
                                        const date = new Date(task.EndDate);
                                        if (!isNaN(date.getTime())) {
                                            r.value = date.toISOString().slice(0, 16);
                                        }
                                    }
                                    catch (err) {
                                        r.value = '';
                                    }
                                }
                            }}

                            onChange={(e) => {
                                setTask(prevTask => ({
                                    ...prevTask,
                                    EndDate: e.target.value ? new Date(e.target.value).toISOString() : null
                                }));
                                SetToSave(true);
                            }}
                            placeholder={t('whenTaskNeedToEnd', { ns: 'labels' })} />

                    </div>
                </div>

                <br></br>

                <div className='row'>
                    <div className='col-6'>
                        <label for="task_planned_start_date" className="form-label">{t('plannedStartDate', { ns: 'labels' })}</label>

                        <input id="task_planned_start_date" type="datetime-local" className="form-control"
                            ref={(r) => {
                                if (!r) return;
                                if (task.PlannedStartDate) {
                                    try {
                                        const date = new Date(task.PlannedStartDate);
                                        if (!isNaN(date.getTime())) {
                                            r.value = date.toISOString().slice(0, 16);
                                        }
                                    }
                                    catch (err) {
                                        r.value = '';
                                    }
                                }
                            }}

                            onChange={(e) => {
                                setTask(prevTask => ({
                                    ...prevTask,
                                    PlannedStartDate: e.target.value ? new Date(e.target.value).toISOString() : null
                                }));
                                SetToSave(true);
                            }}
                            placeholder={t('whenYouPlanToStartTask', { ns: 'labels' })} />

                    </div>

                    <div className='col-6'>
                        <label for="task_planned_end_date" className="form-label">{t('plannedEndDate', { ns: 'labels' })}</label>

                        <input id="task_planned_end_date" type="datetime-local" className="form-control"
                            ref={(r) => {
                                if (!r) return;
                                if (task.PlannedEndDate) {
                                    try {
                                        const date = new Date(task.PlannedEndDate);
                                        if (!isNaN(date.getTime())) {
                                            r.value = date.toISOString().slice(0, 16);
                                        }
                                    }
                                    catch (err) {
                                        r.value = '';
                                    }
                                }
                            }}

                            onChange={(e) => {
                                setTask(prevTask => ({
                                    ...prevTask,
                                    PlannedEndDate: e.target.value ? new Date(e.target.value).toISOString() : null
                                }));
                                SetToSave(true);
                            }}
                            placeholder={t('whenYouPlanToEndTask', { ns: 'labels' })} />

                    </div>
                </div>

                <br></br>
                <div>
                    <ActivityUserLink
                        labelText={t('executor', { ns: 'labels' })}
                        selected={task.ExecutorUsers ?? []}
                        value={'Id'}
                        multiple={true}
                        textDelegate={(item) => {
                            return `${item.LastName} ${item.Name} - ${item.EMail}`
                        }}
                        remoteSource={async (text) => {
                            const usersList = await _remoteSearchUsers(text.text, 'executor');

                            return usersList;
                        }}

                        onChange={(e) => {
                            setTask(prevTask => ({
                                ...prevTask,
                                ExecutorUsers: e
                            }));
                            SetToSave(true);
                        }}


                    ></ActivityUserLink>

                </div>
                <div>
                    <ActivityUserLink
                        labelText={t('verifier', { ns: 'labels' })}
                        selected={task.VerifierUsers ?? []}
                        value={'Id'}
                        multiple={true}
                        textDelegate={(item) => {
                            return `${item.LastName} ${item.Name} - ${item.EMail}`
                        }}
                        remoteSource={async (text) => {
                            const usersList = await _remoteSearchUsers(text.text, 'verifier');

                            return usersList;
                        }}

                        onChange={(e) => {
                            setTask(prevTask => ({
                                ...prevTask,
                                VerifierUsers: e
                            }));
                            SetToSave(true);
                        }}


                    ></ActivityUserLink>

                </div>

                <div>
                    <ActivityUserLink
                        labelText={t('validator', { ns: 'labels' })}
                        selected={task.ValidatorUsers ?? []}
                        value={'Id'}
                        multiple={true}
                        textDelegate={(item) => {
                            return `${item.LastName} ${item.Name} - ${item.EMail}`
                        }}
                        remoteSource={async (text) => {
                            const usersList = await _remoteSearchUsers(text.text, 'validator');

                            return usersList;
                        }}

                        onChange={(e) => {
                            setTask(prevTask => ({
                                ...prevTask,
                                ValidatorUsers: e
                            }));
                            SetToSave(true);
                        }}


                    ></ActivityUserLink>

                </div>
            </div>


        </>
        )

    }


    const _validateTask = () => {

        const errors = [];
        if (task.Name && task.Name == '') {
            errors.push(t('taskNameEmptyError', { ns: 'labels' }));

        }


        return errors;
    }

    const saveTask = async () => {
        const errors = _validateTask();

        if (errors.length > 0) {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: errors.join(','),
                showConfirmButton: true,

            });
        }
        else {

            const result = await api.sendMessage("activity/task/saveTask", {
                user: currentUser(),
                body: {
                    taskToSave: task
                }

            });

            if (result.message == 'Error') {
                withReactContent(Swal).fire({
                    title: t('error', { ns: 'labels' }),
                    icon: "error",
                    text: result.message,
                    showConfirmButton: true
                });
            }
            else {
                withReactContent(Swal).fire({
                    title: t('success', { ns: 'labels' }),
                    icon: "success",
                    text: t('taskUpdatedSuccess', { ns: 'labels' }),
                    showConfirmButton: true,
                    timer: 1500
                });
                SetToSave(false);
            }


        }
    }

    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                </ol>
                <div>

                    <a className="text-primary fs-13" onClick={(e) => {
                        if (toSave) {
                            saveTask();
                        } else {
                            withReactContent(Swal).fire({
                                title: t('info', { ns: 'labels' }),
                                icon: "info",
                                text: t('nothingToSave', { ns: 'labels' }),
                                showConfirmButton: true,
                                timer: 1500
                            });
                        }

                    }} role="button" title={t('saveData', { ns: 'labels' })}><i className="fa-solid fa-floppy-disk fa-2x"></i></a>
                </div>
            </div>

            <div style={{
                width: "100%",
                overflow: "scroll"

            }}>
            </div>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="tab-content" id="tabs-content" style={{ padding: 15 }}>
                                    {task ? (
                                        <>
                                            {_drawTask()}
                                            {/* {editModal()}  */}
                                        </>) : <div className="text-center"><img src={waiting} /></div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}


export default TaskEditor_Screen